import dayjs from 'dayjs';
import md5 from 'crypto-js/md5';

export function getGroupLabel(date) {
  const now = dayjs();
  const pastDate = dayjs(date);

  if (now.isSame(pastDate, 'day')) {
    return 'Today';
  }

  if (now.subtract(1, 'day').isSame(pastDate, 'day')) {
    return 'Yesterday';
  }

  if (now.isSame(pastDate, 'week')) {
    return 'This Week';
  }

  if (now.isSame(pastDate, 'month')) {
    return 'This Month';
  }

  if (now.isSame(pastDate, 'year')) {
    return pastDate.format('MMMM YYYY');
  }

  return pastDate.format('YYYY');
}

export function groupMessagesByTime(messages) {
  const groups = {};

  messages.forEach(message => {
    const date = dayjs(message.timestamp);
    const groupLabel = getGroupLabel(date);

    if (!groups[groupLabel]) {
      groups[groupLabel] = [];
    }

    groups[groupLabel].push(message);
  });

  return Object.entries(groups)
    .sort(([labelA, messagesA], [labelB, messagesB]) => {
      const newestA = Math.max(...messagesA.map(m => new Date(m.timestamp).getTime()));
      const newestB = Math.max(...messagesB.map(m => new Date(m.timestamp).getTime()));
      return newestB - newestA;
    })
    .map(([label, messages]) => ({ label, messages }));
}


export function generateNewSessionId(destination, currentUserUid, domain, smsNumber = null) {

  // For non-SMS messages, continue with normal hash
  if (!smsNumber) {

    if (Array.isArray(destination)) {
      // Group chat
      const numArray = destination.map(dest => `${dest}@${domain}`);
      numArray.push(domain);
      numArray.push(currentUserUid);
      numArray.sort();
      numArray.push(Math.random());
      return md5(numArray.join('')).toString();

    } else {
      // Individual chat
      const numArray = [`${destination}@${domain}`, domain, currentUserUid].sort();
      return md5(numArray.join('')).toString();
    }
  }

  // For SMS messages, include the selected number
  if (Array.isArray(destination)) {
    // Group SMS
    const numArray = [...destination];
    numArray.push(domain);
    numArray.push(currentUserUid);
    numArray.push(smsNumber);
    numArray.sort();
    numArray.push(Math.random());
    return md5(numArray.join('')).toString();


  } else {
    // Individual SMS
    const numArray = [destination, domain, currentUserUid, smsNumber].sort();
    return md5(numArray.join('')).toString();
  }
}

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
